module.exports = __webpack_public_path__ + "static/img/img27.d5dc4a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ychy/img27.png
// module id = hYgh
// module chunks = 1